import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { IndexCoreMyideaApiService } from 'src/api/indexcore-myidea-api/indexcore-myidea-api.service'
import { LauncherInfo } from 'src/api/launcher-api/launcher-api.interface'
import { Wbs } from 'src/api/petabo-api/petabo-api.interface'
import { PetaboApiService } from 'src/api/petabo-api/petabo-api.service'
import { ActionTransactionService } from 'src/app/directive/action-transaction.services'

@Component({
  selector: 'app-petabo-video',
  templateUrl: './petabo-video.component.html',
  styleUrls: ['./petabo-video.component.scss']
})
export class PetaboVideoComponent implements OnInit {
  title = '動画コンテンツ'
  loading = true
  launchers: LauncherInfo[]
  petaboNotificationList: Wbs[] = []
  groupedNotifications: { [key: string]: Wbs[] } = {}
  groupKeys: string[] = []
  public viewCd = 'myidea-video'
  petaboFqdn = 'petabo.myidea.video'

  constructor(private petaboApiService: PetaboApiService, private router: Router) {}

  async ngOnInit(): Promise<void> {
    this.getPetaboList()
  }

  // Petaboからお知らせ取得
  public async getPetaboList(): Promise<void> {
    this.loading = true
    this.petaboNotificationList = []
    const ret = await this.petaboApiService.getPetabo(this.petaboFqdn)
    if (ret?.resultCode !== 0) {
      return
    }
    const now = new Date().getTime()
    let filteredList = ret.data.filter((item) => {
      const start = item.profiles?.periodFrom ? new Date(item.profiles.periodFrom).getTime() : Number.NEGATIVE_INFINITY
      const end = item.profiles?.periodTo ? new Date(item.profiles.periodTo).getTime() : Number.POSITIVE_INFINITY
      return start <= now && now <= end
    })

    // 最新のものを上に表示する createdAtでソート
    // createdAt: '2024-12-12T16:39:32.9062696+09:00'
    // 最新を上に表示するため、降順ソート
    filteredList = filteredList.sort((a, b) => {
      return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    })
    this.petaboNotificationList = filteredList

    // headerTextでグループ化
    this.groupNotificationsByPeriod(filteredList)

    this.loading = false
  }

  // headerTextでグループ化する
  private groupNotificationsByPeriod(notifications: Wbs[]): void {
    this.groupedNotifications = {}

    notifications.forEach((notification) => {
      const headerText = notification.profiles?.headerText
      const groupKey = headerText || 'その他'

      if (!this.groupedNotifications[groupKey]) {
        this.groupedNotifications[groupKey] = []
      }
      this.groupedNotifications[groupKey].push(notification)
    })

    // グループキーをソート（その他を最後に）
    this.groupKeys = Object.keys(this.groupedNotifications).sort((a, b) => {
      if (a === 'その他') return 1
      if (b === 'その他') return -1
      return a.localeCompare(b, 'ja')
    })
  }

  notificationLink(path: string): void {
    if (path?.startsWith('http')) {
      window.open(path, '_blank')
    } else {
      this.router.navigate([path])
    }
  }

  // 画像読み込みエラー時の処理
  onImageError(event: any): void {
    event.target.style.display = 'none'
    // プレースホルダーを表示するため、親要素に class を追加
    event.target.parentElement.classList.add('image-error')
  }
}
